// extracted by mini-css-extract-plugin
export default {"Container":"History_Container__fhLXs","Item":"History_Item__Esq2H","Wrapper":"History_Wrapper__TBnlH","Button":"History_Button__PMEQ+","Arrow":"History_Arrow__TnVfP"};